import { clearActiveClient } from '@/stores/activeClientSlice';
import { store } from '@/stores/store';
import { clearLastClientId } from '@/utils/lastClient';
import axios from 'axios';

// Function to handle token expiry (customize this)
const handleTokenExpiry = () => {
  if (window.location.pathname === '/login') return;
  localStorage.removeItem('role');
  localStorage.removeItem('email');
  sessionStorage.removeItem('role');
  sessionStorage.removeItem('email');
  store.dispatch(clearActiveClient());
  clearLastClientId();
  window.location.href = '/login';
};

const AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 200000,
  withCredentials: true,
});

AxiosInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data.message ===
        'Your token has expired. Please login again.'
    ) {
      handleTokenExpiry(); // Call the custom function when token expires
    }
    return Promise.reject(error);
  }
);

export default AxiosInstance;
